<template>
    <section class="static-featured-articles">
        <KSectionHeader
            class="static-featured-articles__header"
            :text="text"
            align="start"
        >
            <template
                v-if="title"
                #title
            >
                <span v-html="title" />
            </template>
        </KSectionHeader>

        <div class="static-featured-articles__grid">
            <StaticFeaturedArticle
                v-for="item in articles"
                :key="item._uid"
                :item="item"
            />
        </div>
    </section>
</template>

<script setup>
import { KSectionHeader } from '@vemedia/karibu'
import StaticFeaturedArticle from '~/components/featured-articles/static-featured-article.vue'

const { title, text, articles } = defineProps(['title', 'text', 'articles'])
</script>

<style lang="scss">
@use '~/scss/featured-articles-grid' as *;

.static-featured-articles__header {
    margin-bottom: var(--space-6);
}

.static-featured-articles__grid {
    @include featured-articles-grid;
}
</style>
